<template>
  <div id="rentComponent">
    <div v-if="!roundTrip">
      <SearchInput id="journey-from" :place-holder="$t('drive_from')" :pickup-address="true"
        :cities="transportationAddressesDataFalseRoundFirst" :selected-city="store.state.orderFalseRoundTrip.pickUp"
        :message="messagesTrip.validLocationStart" @getCity="getCity($event)" />

      <SearchInput id="journey-to" :place-holder="$t('drive_to')" :is-disabled-input="isDisabledSecondInput"
        :cities="transportationAddressesDataFalseRoundSecond" :selected-city="store.state.orderFalseRoundTrip.dropOff"
        :message="messagesTrip.validLocationDestination" @getCity="getCity($event)" />

      <DatepickerComponent :datepicker-translation="$t('departure')" :default-date="tomorrow" :pickup-date="true"
        :date-store="store.state.orderFalseRoundTrip.tripDepartureDate" @getDate="getDate($event)" />

      <PassengersComponent :passengers-store="store.state.orderFalseRoundTrip.tripPassengers"
        @getPassengers="getPassengers($event)" />

      <template v-if="[routesConst.HOME, routesConst.TRIPS, routesConst.SERVICES_IFRAME].includes($route.name)">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
          @click="onSubmit($event, $route.name)">
          <router-link to="">{{ $t('search') }}</router-link>
        </button>
      </template>

    </div>
    <div v-if="roundTrip">
      <SearchInput id="journey-from" :place-holder="$t('drive_from')" :pickup-address="true"
        :cities="transportationAddressesDataTrueRoundFirst" :selected-city="store.state.orderTrueRoundTrip.pickUp"
        :message="messagesRound.validLocationStart" @getCity="getCity($event)" />

      <SearchInput id="journey-to" :place-holder="$t('drive_to')" :is-disabled-input="isDisabledSecondInput"
        :cities="transportationAddressesDataTrueRoundSecond" :selected-city="store.state.orderTrueRoundTrip.dropOff"
        :message="messagesRound.validLocationDestination" @getCity="getCity($event)" />

      <DatepickerComponent :datepicker-translation="$t('departure')" :default-date="tomorrow" :pickup-date="true"
        :date-store="store.state.orderTrueRoundTrip.tripDepartureDate" :is-valid="messagesRound.validDate.state"
        :message="messagesRound.validDate.message" @getDate="getDate($event)" />

      <DatepickerComponent :datepicker-translation="$t('the_return')" :default-date="week"
        :date-store="store.state.orderTrueRoundTrip.tripArrivalDate" :is-valid="messagesRound.validDate.state"
        :message="messagesRound.validDate.message" @getDate="getDate($event)" />

      <PassengersComponent :passengers-store="store.state.orderTrueRoundTrip.tripPassengers"
        @getPassengers="getPassengers($event)" />

      <template
        v-if="[routesConst.HOME, routesConst.ROUND_TRIP_FIRST_STEP, routesConst.ROUND_TRIP_SECOND_STEP, routesConst.SERVICES_IFRAME].includes($route.name)">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
          @click="onSubmit($event, $route.name)">
          <router-link to="">{{ $t('next') }}</router-link>
        </button>
      </template>
    </div>
  </div>

  <span class="custom-route-error-color font-small" v-for="error in backEndErrorMessages" :key="error">
    {{ $t(error) }}
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import './Transportation.scss';
import { useStore } from "vuex";
import axios from "axios";

// @ts-ignore
import { TransportationComponentErrorMessages } from "../../../interfaces/enums/TransportationComponentErrorMessages.enum";
import formValidationService from '../../../services/formValidationService';
import { routesConst } from "../../../routes";

import apiService from "../../../services/apiService";
import { axiosHelpers } from "../../../helpers/axiosHelpers";
import NameOfHelper from '../../../helpers/nameOfHelper';
import type { IApiResponseTransportationAddress } from "../../../interfaces/apiResponseInterfaces/IApiResponseTransportationAddress.interface";

// @ts-ignore
import AddressSelectComponent from "../../AddressSelect/AddressSelectComponent.vue";
// @ts-ignore
import PassengersComponent from "../../Passengers/PassengersComponent.vue";
// @ts-ignore
import TimePickerComponent from "../../TimePicker/TimePickerComponent.vue";
// @ts-ignore
import SearchInput from "../../searchInput/SearchInput.vue";
// @ts-ignore
import DatepickerComponent from "../../Datepicker/DatePickerComponent.vue";
import { dateHelpers } from "../../../helpers/dateHelpers";
import store from "../../../store";

export default defineComponent({
  name: 'TransportationComponent',
  emits: ['on-search-submit'],
  components: {
    TimePickerComponent,
    PassengersComponent,
    AddressSelectComponent,
    DatepickerComponent,
    SearchInput
  },
  props: {
    roundTrip: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },

  data() {
    return {
      routesConst: routesConst,
      tomorrow: <null | Date>null,
      week: <null | Date>null,
      backEndErrorMessages: <string[]>[],
      disabled: false,
      messagesTrip: {
        validLocationStart: {
          state: true,
          message: null as string | null
        },
        validLocationDestination: {
          state: true,
          message: null as string | null
        },
      },
      messagesRound: {
        validLocationStart: {
          state: true,
          message: null as string | null
        },
        validLocationDestination: {
          state: true,
          message: null as string | null
        },
        validDate: {
          state: true,
          message: null as string | null
        },
      },
      transportationAddressesDataFalseRoundFirst: <IApiResponseTransportationAddress[]>[],
      transportationAddressesDataFalseRoundSecond: <IApiResponseTransportationAddress[]>[],
      transportationAddressesDataTrueRoundFirst: <IApiResponseTransportationAddress[]>[],
      transportationAddressesDataTrueRoundSecond: <IApiResponseTransportationAddress[]>[],
      isDisabledFormSubmit: true,
      isDisabledSecondInput: true,
    }
  },

  methods: {
    handleAxiosCitiesRequest(data: IApiResponseTransportationAddress | null): void {
      axios.get(apiService.getCitiesEndpoint(), {
        params:
        {
          cityId: data!.id
        }
      })
        .then(response => {
          const responseData: IApiResponseTransportationAddress[] = response.data.map(el => ({
            id: el.id,
            city: el.city,
            address: el.address,
            address_to_show: el.address_to_show,
          }));

          !this.roundTrip ?
            this.transportationAddressesDataFalseRoundSecond = responseData :
            this.transportationAddressesDataTrueRoundSecond = responseData;
        })
        .catch(error => {
          this.backEndErrorMessages = axiosHelpers.handleAxiosErrors(error);
        })
    },

    initialAxiosCitiesRequest(): void {
      axios.get(apiService.getCitiesEndpoint())
        .then(response => {
          const responseData: IApiResponseTransportationAddress[] = response.data.map(el => ({
            id: el.id,
            city: el.city,
            address: el.address,
            address_to_show: el.address_to_show,
          }));

          this.transportationAddressesDataFalseRoundFirst =
            this.transportationAddressesDataTrueRoundFirst = responseData;
        })
        .catch(error => {
          this.backEndErrorMessages = axiosHelpers.handleAxiosErrors(error);
        })
    },

    getCity(payload: { value: IApiResponseTransportationAddress, pickup: boolean }): void {
      const action = !this.roundTrip ? 'orderFalseRoundTrip/updateState' : 'orderTrueRoundTrip/updateState';
      const state = !this.roundTrip ? this.store.state.orderFalseRoundTrip : this.store.state.orderTrueRoundTrip

      const nameOf = (c) => NameOfHelper.obj(c);
      const pickUp = nameOf(() => state.pickUp);
      const dropOff = nameOf(() => state.dropOff);

      const prop: string = !payload.pickup ? dropOff : pickUp;

      this.store.dispatch(action, [{ prop, value: payload.value }]);

      if (payload.pickup) {
        this.handleAxiosCitiesRequest(payload.value);
        this.isDisabledSecondInput = !payload.value!.city;
      }
    },

    getDate(payload: { value: string, pickup: boolean }): void {

      let action: string | null = null;
      let prop: string = !payload.pickup ? 'tripArrivalDate' : 'tripDepartureDate';

      if (!payload.pickup) {
        action = 'orderTrueRoundTrip/updateState';
      } else {
        action = !this.roundTrip ? 'orderFalseRoundTrip/updateState' : 'orderTrueRoundTrip/updateState';
      }

      this.store.dispatch(action, [{ prop, value: payload.value }]);
    },

    getPassengers(payload: number): void {
      let action = !this.roundTrip ? 'orderFalseRoundTrip/updateState' : 'orderTrueRoundTrip/updateState';
      let prop: string = 'tripPassengers';

      this.store.dispatch(action, [{ prop, value: payload }]);
    },

    onSubmit(event: Event, route?: routesConst | undefined): void {
      let isValid = true;
      const roundTrip = this.roundTrip;

      const stateName = !roundTrip ? 'orderFalseRoundTrip' : 'orderTrueRoundTrip';
      const state = !roundTrip ? this.store.state.orderFalseRoundTrip : this.store.state.orderTrueRoundTrip;
      const action = stateName + '/SET_TRANSPORTATION_FORM_VALID';

      if (roundTrip) {

        isValid = formValidationService.validateTransportation({
          start: state.pickUp,
          destination: state.dropOff,
          startDate: state.tripDepartureDate,
          endDate: state.tripArrivalDate
        }, this.messagesRound);

      } else {

        isValid = formValidationService.validateTransportation({
          start: state.pickUp,
          destination: state.dropOff
        }, this.messagesTrip);
      }

      this.store.commit(action, isValid);

      if (!isValid) {
        console.warn('Form not valid');
        return;
      }

      // Reset
      if (roundTrip) {
        this.store.state.orderTrueRoundTrip.forwardTicket = {
          transportationId: null,
          isSelected: false,
          data: null,
          tripDate: null,
          pickUp: null,
          dropOff: null,
          pickup_specified_address: "",
          dropoff_specified_address: "",
          pickup_note: "",
          dropoff_note: ""
        };

        this.store.state.orderTrueRoundTrip.backTicket = {
          transportationId: null,
          isSelected: false,
          data: null,
          tripDate: null,
          pickUp: null,
          dropOff: null,
          pickup_specified_address: "",
          dropoff_specified_address: "",
          pickup_note: "",
          dropoff_note: ""
        };
      }

      if (route) {
        switch (route) {
          case routesConst.HOME:
            !roundTrip ? this.$router.push(routesConst.TRIPS) : this.$router.push(routesConst.ROUND_TRIP_FIRST_STEP);
            break;

          case routesConst.TRIPS:
          case routesConst.ROUND_TRIP_FIRST_STEP:
          case routesConst.ROUND_TRIP_SECOND_STEP:
            this.$emit('on-search-submit');
            this.$router.push(route);
            break;

          case routesConst.SERVICES_IFRAME:
            const stateToSend = { ...state };
            delete stateToSend.defaultState;

            const orderStateToSend = {
              'withDriver': this.store.state.order.withDriver,
              'roundTrip': this.store.state.order.roundTrip,
              'serviceType': this.store.state.order.serviceType,
            };

            const payload = { stateName, state: stateToSend, orderState: orderStateToSend };

            const url = store.getters.appUrl + '?state=' + btoa(encodeURIComponent(JSON.stringify(payload)));

            parent.postMessage("redirect::" + url, "*");
            break;
        }
      }
    }
  },

  created() {
    this.tomorrow = dateHelpers.getDefaultDate(1);
    this.week = dateHelpers.getDefaultDate(7);

    this.initialAxiosCitiesRequest();

    const state = !this.roundTrip ? this.store.state.orderFalseRoundTrip : this.store.state.orderTrueRoundTrip;
    if (state.pickUp.city) {
      this.handleAxiosCitiesRequest(state.pickUp);
      this.isDisabledSecondInput = false;
    }
  },

});

</script>